import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations } from 'vuexfire'

Vue.use(Vuex);

import auth from './auth';
import bind from './plugins/bind';
import feeds from './feeds';
import user from './user';
import vueTime, {onTheMinute} from './plugins/time.js';

export default new Vuex.Store({
  mutations: {
    ...vuexfireMutations
  },
  modules: {
    auth,
    feeds,
    user
  },
  plugins: [
    bind,
    vueTime({interval: onTheMinute})
  ]
})
